import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
// import {AuthService} from '../../shared/auth/auth.service';
import {ThreatService, CognitoAuthService, AutoRefreshService, StoreService} from '../../shared';

@Component({
    selector: 'top-nav',
    templateUrl: './top-nav.component.html',
    styleUrls: ['./top-nav.component.css'],
    providers: [CognitoAuthService, ThreatService]
})
export class TopNavComponent implements OnInit {

    isLoading: boolean;
    threatLevel: any;

    timePeriods: any[];
    currentTimePeriodIndex: number;

    autoRefreshIntervalNames: string[ ];
    currentAutoRefreshIntervalName: string;
    autoRefreshIntervals: number[ ];

    userName: string;

    constructor(private router: Router,
                private store: StoreService,
                private authService: CognitoAuthService,
                private threatService: ThreatService,
                private autoRefreshService: AutoRefreshService) {
        this.isLoading = true;
        this.threatLevel = {risk: null};

        this.timePeriods = [
            // value is in milliseconds
            {
                name: 'Last 24 hours',
                value: 'd'
            },
            {
                name: 'Last 7 days',
                value: 'w'
            },
            {
                name: 'Last 30 days',
                value: 'm'
            }
        ];
        this.currentTimePeriodIndex = 1; // default time period is 'Last 7 days'

        this.autoRefreshIntervalNames = ['30 seconds', '1 minute', '5 minutes', '10 minutes'];
        this.currentAutoRefreshIntervalName = null;
        this.autoRefreshIntervals = [30 * 1000, 60 * 1000, 300 * 1000, 600 * 1000];

        this.userName = 'Account';
    }

    ngOnInit() {
        const self = this;

        this.authService.getIdToken({
            callback() {
            },
            callbackWithParam(idToken: any) {
                // console.log('ID Token = ', idToken);
                const customer = self.authService.decodeToken(idToken)['custom:customer'];
                const un = self.authService.decodeToken(idToken)['name'];
                if (un) {
                    self.userName = un;
                }
                // console.log('customer = ', customer);
                self.threatService.getThreatLevel(idToken, customer).subscribe(function (threatLevel) {
                    if (threatLevel !== null && threatLevel[0] !== null) {
                        // console.log('threatLevel = risk: ' + threatLevel[0].risk);
                        self.threatLevel = threatLevel[0];
                        self.isLoading = false;
                    }
                });
            }
        });

        this.setTimePeriod(this.currentTimePeriodIndex);

        // On initialization, set auto refresh to 60 secs
        // TODO: is there a better way to do this, rather than hardcode?
        //this.setAutoRefresh(1);
    }

    setAutoRefresh(i) {
        if (i == null) {

            this.autoRefreshService.setAutoRefresh(null);
            this.currentAutoRefreshIntervalName = null;
        } else {

            const interval = this.autoRefreshIntervals[i];
            this.autoRefreshService.setAutoRefresh(interval);
            this.currentAutoRefreshIntervalName = this.autoRefreshIntervalNames[i];
        }
    }

    setTimePeriod(i) {
        this.currentTimePeriodIndex = i;
        this.store.update('timePeriod', this.timePeriods[i].value);
    }

    signOut() {
        const self = this;

        // unsubscribe from autorefresh if we are doing it
        if (this.currentAutoRefreshIntervalName != null) {
            this.autoRefreshService.setAutoRefresh(null);
        }

        this.authService.signOut();
        self.isLoading = true;
        self.router.navigate(['sign-in']);
    }
}



// WEBPACK FOOTER //
// /app/src/app/ui/top-nav/top-nav.component.ts